import { render, staticRenderFns } from "./WaitMessage.vue?vue&type=template&id=585e2e16&"
import script from "./WaitMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./WaitMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./WaitMessage.vue?vue&type=style&index=0&id=585e2e16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports